import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import CONSTANTS from '../../_constants/constants';
import { environment } from '../../../environments/environment';
import { DefaultParams } from '../../_shared/interfaces/defaultParams';

import { UtilService } from '../../_shared/services/util.service';

import { Location } from './location.model';

interface ExtendedDefaultParams extends DefaultParams {
  by_name?: any;
  by_parentLocation?: any;
  by_country?: any;
}

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  private apiUrl = environment.apiEndpoint + 'locations';

  constructor(private http: HttpClient, private utilService: UtilService) {}

  getFilterCriteria() {
    let defaultParams: ExtendedDefaultParams = {
      // let defaultParams = {
      page: 1,
      sortDir: 'asc',
      sortedBy: 'name',
    };

    return defaultParams;
  }

  getLocations(params = null): Observable<any> {
    if (!params) {
      params = this.getFilterCriteria();
    }

    let queryParams = new HttpParams({ fromObject: params });

    return this.http.get(this.apiUrl, { params: queryParams }).pipe(
      map((resp) => {
        if (resp['data']) {
          return {
            data: resp['data'],
            meta: this.utilService.getItemsMetaData(resp, this.getFilterCriteria()),
          };
        } else {
          return resp;
        }
      })
    );
  }

  getLocation(id: string, params = null): Observable<Location> {
    let queryParams = new HttpParams({ fromObject: params });

    // If we want to update the obj
    return this.http
      .get<Location>(`${this.apiUrl}/${id}`, {
        params: queryParams,
      })
      .pipe(
        map((resp) => {
          resp.logoUrl = this.utilService.cleanItemCache(resp, 'logo');
          return resp;
        })
      );
  }

  // Save / Update
  saveLocation(
    locationId: string,
    location: Location,
    lang = '',
    photo = null
  ): Observable<Location> {
    const formData = new FormData();

    // Create and photo evaluated
    if (!locationId && photo) {
      // Store form name as "file" with file data
      formData.append('file', photo, photo.name);
    }

    formData.append('lang', lang || CONSTANTS.DEFAULT_CONTENT_LANGUAGE);

    for (let key in location) {
      // Required when using new FormData
      if (Array.isArray(location[key])) {
        location[key].forEach((item) => formData.append('location[' + key + '][]', item));
      } else {
        formData.append('location[' + key + ']', location[key]);
      }
    }

    if (!locationId) {
      return this.http.post<Location>(`${this.apiUrl}`, formData);
    } else {
      return this.http.put<Location>(`${this.apiUrl}/${locationId}`, formData);
    }
  }

  updatePickupLogo(locationId, photo): Observable<any> {
    const formData: FormData = new FormData();

    // Store form name as "file" with file data
    formData.append('file', photo, photo.name);
    formData.append('location[id]', locationId);

    return this.http.put<Location>(`${this.apiUrl}/${locationId}`, formData);
  }

  groupLocations(items) {
    // , itemId = '', option = 'locations'
    const superLocations = [];

    items.forEach((item) => {
      if (item.is_superior_location) {
        //  && item.id !== itemId
        const locations = [];

        items.forEach((location) => {
          if (location.parentLocation_id === item.id) {
            //  && location.id !== itemId
            // if (option !== 'parents') {
            const subLocations = [];

            items.forEach((subLocation) => {
              if (subLocation.parentLocation_id === location.id) {
                subLocations.push(subLocation);
              }
            });

            location.locations = subLocations;
            // }

            locations.push(location);
          }
        });

        item.locations = locations;

        if (locations.length === 0) {
          item.locations = [{}];
        }

        superLocations.push(item);
      }
    });

    function flattenLocations(
      locations,
      // option,
      treelevel = 0,
      parentLocationName = '',
      parentLocationId = ''
    ) {
      if (!treelevel) {
        treelevel = 1;
      }

      const flat = [];

      locations.forEach((location) => {
        const item = {
          id: location.id,
          name: location.name,
          geo_lat: location.geo_lat,
          geo_lng: location.geo_lng,
          logo: location.logo,
          is_superior_location: location.is_superior_location,
          treelevel: treelevel,
          parent: parentLocationName,
          parentLocationId: parentLocationId,
        };

        if (!location.is_superior_location) {
          //  || option === 'parents'
          flat.push(item);
        }

        // console.log(location);

        if (location.locations) {
          // console.log(parent);

          // const parentLocationName = parent ? parent : location.name;
          // const parentLocationId = parent ? parent : location.id;

          const parentLocationName = location.name;
          const parentLocationId = location.parentLocation_id;
          const countryId = location.country_id;

          const childLocations = flattenLocations(
            location.locations,
            // option,
            treelevel + 1,
            parentLocationName,
            parentLocationId
          );

          if (childLocations.length) {
            flat.push.apply(flat, childLocations);
          }
        }
      });

      return flat;
    }

    return flattenLocations(superLocations); // , option
  }
}
